// Tailwind-safe color tokens for BTW workflow statussen.
// All class strings are literals so Tailwind's content scanner picks them up.
export const COLOR_CLASSES = {
  slate: {
    pill: "bg-slate-100 text-slate-700",
    dot: "bg-slate-500",
    column: "bg-slate-50",
    columnHeader: "border-slate-300 text-slate-700",
    edge: "bg-slate-400",
  },
  gray: {
    pill: "bg-gray-100 text-gray-700",
    dot: "bg-gray-500",
    column: "bg-gray-50",
    columnHeader: "border-gray-300 text-gray-700",
    edge: "bg-gray-400",
  },
  sky: {
    pill: "bg-sky-100 text-sky-800",
    dot: "bg-sky-500",
    column: "bg-sky-50",
    columnHeader: "border-sky-300 text-sky-800",
    edge: "bg-sky-400",
  },
  blue: {
    pill: "bg-blue-100 text-blue-800",
    dot: "bg-blue-500",
    column: "bg-blue-50",
    columnHeader: "border-blue-300 text-blue-800",
    edge: "bg-blue-400",
  },
  indigo: {
    pill: "bg-indigo-100 text-indigo-800",
    dot: "bg-indigo-500",
    column: "bg-indigo-50",
    columnHeader: "border-indigo-300 text-indigo-800",
    edge: "bg-indigo-400",
  },
  violet: {
    pill: "bg-violet-100 text-violet-800",
    dot: "bg-violet-500",
    column: "bg-violet-50",
    columnHeader: "border-violet-300 text-violet-800",
    edge: "bg-violet-400",
  },
  fuchsia: {
    pill: "bg-fuchsia-100 text-fuchsia-800",
    dot: "bg-fuchsia-500",
    column: "bg-fuchsia-50",
    columnHeader: "border-fuchsia-300 text-fuchsia-800",
    edge: "bg-fuchsia-400",
  },
  pink: {
    pill: "bg-pink-100 text-pink-800",
    dot: "bg-pink-500",
    column: "bg-pink-50",
    columnHeader: "border-pink-300 text-pink-800",
    edge: "bg-pink-400",
  },
  rose: {
    pill: "bg-rose-100 text-rose-800",
    dot: "bg-rose-500",
    column: "bg-rose-50",
    columnHeader: "border-rose-300 text-rose-800",
    edge: "bg-rose-400",
  },
  red: {
    pill: "bg-red-100 text-red-800",
    dot: "bg-red-500",
    column: "bg-red-50",
    columnHeader: "border-red-300 text-red-800",
    edge: "bg-red-400",
  },
  orange: {
    pill: "bg-orange-100 text-orange-800",
    dot: "bg-orange-500",
    column: "bg-orange-50",
    columnHeader: "border-orange-300 text-orange-800",
    edge: "bg-orange-400",
  },
  amber: {
    pill: "bg-amber-100 text-amber-800",
    dot: "bg-amber-500",
    column: "bg-amber-50",
    columnHeader: "border-amber-300 text-amber-800",
    edge: "bg-amber-400",
  },
  yellow: {
    pill: "bg-yellow-100 text-yellow-800",
    dot: "bg-yellow-500",
    column: "bg-yellow-50",
    columnHeader: "border-yellow-300 text-yellow-800",
    edge: "bg-yellow-400",
  },
  lime: {
    pill: "bg-lime-100 text-lime-800",
    dot: "bg-lime-500",
    column: "bg-lime-50",
    columnHeader: "border-lime-300 text-lime-800",
    edge: "bg-lime-400",
  },
  emerald: {
    pill: "bg-emerald-100 text-emerald-800",
    dot: "bg-emerald-500",
    column: "bg-emerald-50",
    columnHeader: "border-emerald-300 text-emerald-800",
    edge: "bg-emerald-400",
  },
  green: {
    pill: "bg-green-100 text-green-800",
    dot: "bg-green-500",
    column: "bg-green-50",
    columnHeader: "border-green-300 text-green-800",
    edge: "bg-green-400",
  },
  teal: {
    pill: "bg-teal-100 text-teal-800",
    dot: "bg-teal-500",
    column: "bg-teal-50",
    columnHeader: "border-teal-300 text-teal-800",
    edge: "bg-teal-400",
  },
  cyan: {
    pill: "bg-cyan-100 text-cyan-800",
    dot: "bg-cyan-500",
    column: "bg-cyan-50",
    columnHeader: "border-cyan-300 text-cyan-800",
    edge: "bg-cyan-400",
  },
};

export const COLOR_OPTIONS = Object.keys(COLOR_CLASSES);

export const getStatusColor = (color) =>
  COLOR_CLASSES[color] ?? COLOR_CLASSES.slate;

export const initialsFromName = (name = "") =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("") || "?";

export const daysSince = (dateLike) => {
  if (!dateLike) return null;
  const t = new Date(dateLike).getTime();
  if (Number.isNaN(t)) return null;
  return Math.floor((Date.now() - t) / (1000 * 60 * 60 * 24));
};
